module.exports = __webpack_public_path__ + "static/media/SCR058.e5a4a966.mp3";